import React from "react";
import { UserLink } from "@/app/(components)/Application/User/UserLink";
import { ShortUser } from "@/api/users/types";

export interface Props {
  text: string;
  args?: Args[];
}

interface Args {
  user?: ShortUser;
  text?: string;
  link?: boolean;
}

const NftActivityDescripitonItem = ({ text, args }: Props) => {
  const elements = text.split(" ").reduce((result: string[], item: string) => {
    if (
      !result.length ||
      item.match(/{\d+}/) ||
      result[result.length - 1].match(/{\d+}/)
    ) {
      return [...result, item];
    } else {
      const lastItem = result.pop();
      return [...result, `${lastItem} ${item}`];
    }
  }, []);

  return (
    <div className="flex h-auto endemic:text-secondary flex-wrap gap-x-1">
      {elements.map((element, index) => {
        const match = element.match(/{(?<order>\d+)}/);
        if (!match?.groups?.order) {
          return <span key={index}>{element.trim()}</span>;
        }

        const order = parseInt(match.groups.order, 10);
        if (!args) return;
        const item = args[order];
        if (item.link && item.user) {
          return (
            <UserLink
              key={index}
              className={`${
                item.user.hideProfile
                  ? "text-primary"
                  : "text-red endemic:text-yellow"
              }`}
              artist={item.user}
              tooltipPosition={["center", "top"]}
            >
              {item.text}
            </UserLink>
          );
        } else {
          return (
            <span className="text-primary" key={index}>
              {item.text}
            </span>
          );
        }
      })}
    </div>
  );
};

export default NftActivityDescripitonItem;
